import React, { useState, useEffect } from "react";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../../CustomComponents/CustomCard/CustomCard";
import CustomTypography from "../../CustomComponents/CustomTypography/CustomTypography";
import CustomCardContent from "../../CustomComponents/CustomCardContent/CustomCardContent";
import CustomPlayer from "../../CustomComponents/CustomPlayer/CustomPlayer";
import { useStyles } from "../../../assets/jss/ContentDetails";
import CustomCircularProgress from "../../CustomComponents/CustomCircularProgress/CustomCircularProgress";

export default function VideoComponentPreview(props) {
  const classes = useStyles();
  const [content, setContent] = useState(null);
  const [mediaLoader, setMediaLoader] = useState(true);

  useEffect(() => {
    if (props.content) {
      setContent(props.content);
    }
  }, [props.content]);

  return (
    <>
      <CustomPaper elevation={0}>
        <CustomCard elevation={0} className={classes.cardContentWrapper}>
          <CustomCardContent className={classes.cardContent}>
            {content && (
              <>
                <CustomBox className={classes.cardContentBody}>
                  {content.title && (
                    <CustomTypography
                      component="h3"
                      variant="h3"
                      className={classes.headerTitle}
                    >
                      {content.title}
                    </CustomTypography>
                  )}
                  {content.contentPath && (
                    <CustomBox className={classes.mediaWrapper}>
                      {mediaLoader ? (
                        <CustomCircularProgress
                          className={classes.mediaWrapperLoader}
                        />
                      ) : null}
                      <CustomPlayer
                        className={classes.praisoPlayer}
                        onReady={() => setMediaLoader(false)}
                        controls={true}
                        config={{
                          vimeo: {
                            responsive: true,
                          },
                        }}
                        // url="https://vimeo.com/180293809"
                        url={content.contentPath}
                      />
                    </CustomBox>
                  )}
                </CustomBox>
              </>
            )}
          </CustomCardContent>
        </CustomCard>
      </CustomPaper>
    </>
  );
}
